import React from "react";

import { Activity } from "store/campaigns/campaignActivities/campaignActivities.types";

import * as S from "./index.styles";
import EventItem from "components/Projects/EventItem";

interface FundraisingDetailEventsProps {
  events: Activity[];
  onSeeAll?: () => void;
}

const FundraisingDetailEvents: React.FC<FundraisingDetailEventsProps> = ({
  events = [],
  onSeeAll,
}) => {
  const displayedEvents = events?.slice(0, 2);
  return (
    <S.EventsSection>
      <S.EventsSectionHeader>
        <S.EventsSectionTitle>Related Events</S.EventsSectionTitle>
        {/*events?.length > 2 && (
          <S.SeeAllLink type="button" onClick={onSeeAll}>
            see all
          </S.SeeAllLink>
        )}*/}
      </S.EventsSectionHeader>
      {displayedEvents.length > 0 ? (
        displayedEvents.map((event, key) => (
          <EventItem key={key} event={event} />
        ))
      ) : (
        <S.EventsEmptyState>No events found</S.EventsEmptyState>
      )}
    </S.EventsSection>
  );
};

export default FundraisingDetailEvents;
